export default __webpack_public_path__ + "static/media/BlackFrame03.455dac07.png";